/**
 * Runtime env surface. Validated at bootstrap so a missing var fails
 * loudly in dev/prod rather than silently at first fetch.
 *
 * All keys must be prefixed `VITE_` to reach the browser.
 */

import { z } from 'zod';

const schema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  VITE_KEYCLOAK_URL: z.string().url(),
  VITE_KEYCLOAK_REALM: z.string().min(1),
  VITE_KEYCLOAK_CLIENT_ID: z.string().min(1),
  VITE_SENTRY_DSN: z.string().url().optional().or(z.literal('').optional()),
});

const parsed = schema.safeParse(import.meta.env);
if (!parsed.success) {
   
  console.error('Invalid VITE_* env:', parsed.error.flatten().fieldErrors);
  throw new Error(
    'Invalid runtime env — see console for the missing keys. ' +
      'Copy `.env.example` to `.env.local` and fill the values.'
  );
}

export const env = {
  apiBaseUrl: parsed.data.VITE_API_BASE_URL,
  keycloak: {
    url: parsed.data.VITE_KEYCLOAK_URL,
    realm: parsed.data.VITE_KEYCLOAK_REALM,
    clientId: parsed.data.VITE_KEYCLOAK_CLIENT_ID,
  },
  sentryDsn: parsed.data.VITE_SENTRY_DSN || undefined,
} as const;
